




















import { mapGetters } from 'vuex'
import LoadingSpinner from './LoadingSpinner.vue'

export default {
  components: {
    LoadingSpinner
  },
  props: {
    loadingInitially: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters(['isBannerOpen']),
    hasSubHeader() {
      return !!this.$slots.header
    },
    hasFooter() {
      return !!this.$slots.footer
    },
    isIframe() {
      return this.$route.query.iframe
    },
    subHeaderClasses() {
      return {
        'sub-header': true,
        'sub-header--with-banner': this.isBannerOpen
      }
    },
    contentClasses() {
      return {
        'main-content': true,
        'main-content--with-sub-header': this.hasSubHeader,
        'main-content--with-banner': this.isBannerOpen,
        'main-content--with-banner-and-sub-header':
          this.hasSubHeader && this.isBannerOpen,
        'main-content--with-footer': this.hasFooter
      }
    }
  }
}
